import {useState, useContext} from "react"
import { UserContext } from '../Context/UserContext';
import "../styles/matchupBuilder.css"
import RatingDropDown from "./RatingDropDown"
import SingleGameTeamTrends from "./SingleGameTeamTrends";
import SingleGameTable from "./SingleGameTable";
import useUserGamePolling from "../hooks/useUserGamePolling"
import useCreateUserGame from "../hooks/useCreateUserGame";
import {useIsMobile} from "../hooks/useIsMobile"
import SingleGameMobileList from "./SingleGameMobileList";
import NotPremium from "./NotPremium";
import HomeGameBar from "./HomeGameBar";

export default function MatchupBuilder() {
    const {state, dispatch, isActiveSub} = useContext(UserContext);
    const [hideSelectOrCreateMatchups, setHideSelectOrCreateMatchups] = useState(false)
    const {mostRecentGame, mostRecentTeamTrends, setMostRecentGame, setMostRecentTeamTrends} = useUserGamePolling(dispatch)
    const { createUserGame, loading, error } = useCreateUserGame(dispatch)
    const [ratingTimeframe, setRatingTimeframe] = useState(false)
    const [matchupState, setMatchupState] = useState({awayTeam: "", homeTeam: "", awayPitcher: "", homePitcher: ""})
    const teams = Object.keys(state.teamColors)
    const isMobile = useIsMobile(768)
    //console.log('isMobile', isMobile)
    const allFieldsFilled = matchupState.awayTeam && matchupState.awayPitcher && matchupState.homeTeam && matchupState.homePitcher;
    const isCalculating = loading || (mostRecentGame && mostRecentGame.calculation_status !== "done");

    function handleChange(e) {
        const {name, value} = e.target

        setMatchupState(prev => ({
            ...prev,
            [name]: value,
            ...(name === "awayTeam" && { awayPitcher: "" }),
            ...(name === "homeTeam" && { homePitcher: "" })
        }))
    }

    function handleRatingTimeFrameChange() {
        setRatingTimeframe(prev => !prev)
    }

    async function handleSubmit(event) {
        event.preventDefault()

         if (!matchupState.awayTeam || !matchupState.awayPitcher || !matchupState.homeTeam || !matchupState.homePitcher) return;

        const postData = {
            away_team: matchupState.awayTeam,
            away_team_SP: matchupState.awayPitcher,
            home_team: matchupState.homeTeam,
            home_team_SP: matchupState.homePitcher
        }

        const data = await createUserGame(postData)

        if (data) {
            setMostRecentGame(data)
        }
    }

    function handleSelectMatchup(e) {
        if (e.target.value !== "Choose...") {
            const relGame = state.userGames?.find((ug) => String(ug.away_pitcher_id) === e.target.value)
            //want find instead of filter because filter returns new array, find just gets the first one so no array which is better for the hooks I have set up because they are set up to get a json object from the API so I want to keep the same format obviously
            const relTeamTrends = state.userGameTeamTrends.filter((ugtt) => ugtt.user_game_id === relGame.id)
            setMostRecentGame(relGame)
            setMostRecentTeamTrends(relTeamTrends)
        }
        else {
            setMostRecentGame(null)
            setMostRecentTeamTrends(null)
        }
    }

    function handleHide() {
        setHideSelectOrCreateMatchups(prev => !prev)
    }

    return (
        <div>
            <HomeGameBar />
            {isActiveSub && (
                <div className="matchupBuilderContainer">
                    {state.userGames.length > 0 ? (<h1>Select A Matchup or Create A New One</h1>) : (<h1>Create Matchup</h1>)}
                    <button onClick={handleHide}>{hideSelectOrCreateMatchups ? "Show Create Matchup" : "Hide Create Matchup"}</button>
                    {hideSelectOrCreateMatchups === false && state.userGames.length > 0 && (<div>
                        <label>Select A Matchup: </label>
                        <select onChange={handleSelectMatchup}>
                            <option>Choose...</option>
                            {state.userGames.map(ug => {
                                const awaySP = state.pitchers?.filter((p) => p.id === ug.away_pitcher_id)
                                const homeSP = state.pitchers?.filter((p) => p.id === ug.home_pitcher_id)
                                return (
                                    <option key={ug.id} value={ug.away_pitcher_id}>{awaySP[0]?.name} ({ug.away_team}) vs {homeSP[0]?.name} ({ug.home_team})</option>
                                )
                            })}
                        </select>
                    </div>)}
                    <br />
                    {hideSelectOrCreateMatchups === false && (<div className="formContainer">
                        <h2>Create New Matchup</h2>
                        <h3>Select a Team First</h3>
                        <br />
                        <form className="matchupForm" onSubmit={handleSubmit}>
                            <label>Select Away Team: </label>
                            <select value={matchupState.awayTeam} name="awayTeam" onChange={handleChange}>
                                <option>Choose...</option>
                                {teams.map(team => {
                                    return (
                                        <option key={team} value={team}>{team}</option>
                                    )
                                })}
                            </select>
                            <label>Select Away Pitcher: </label>
                            <select value={matchupState.awayPitcher} name="awayPitcher" onChange={handleChange}>
                                {state.pitchers
                                    .filter(pit => pit.team === matchupState.awayTeam)
                                    .map(p => (
                                        <option key={p.id} value={p.name}>{p.name}</option>
                                    )
                                )}
                            </select>
                            <label>Select Home Team: </label>
                            <select value={matchupState.homeTeam} name="homeTeam" onChange={handleChange}>
                                <option>Choose...</option>
                                {teams.map(team => {
                                    return (
                                        <option key={team} value={team}>{team}</option>
                                    )
                                })}
                            </select>
                            <label>Select Home Pitcher: </label>
                            <select value={matchupState.homePitcher} name="homePitcher" onChange={handleChange}>
                                {state.pitchers
                                    .filter(pit => pit.team === matchupState.homeTeam)
                                    .map(p => (
                                        <option key={p.id} value={p.name}>{p.name}</option>
                                    )
                                )}
                            </select>
                            <button type="submit" disabled={isCalculating || !allFieldsFilled}>{isCalculating ? "Creating..." : "Create Matchup"}</button>
                        </form>
                        {!allFieldsFilled && (
                            <p className="error">Please fill out all fields before submitting</p>
                        )}
                    </div>)}
                    {isCalculating && (
                        <p id="runningCalculations">Running Calculations...Please Wait Up to 15 Seconds</p>
                    )}
                    {error && (
                        <p className="error">Calculations failed. {`${error.message}`}</p>
                    )}
                    {(mostRecentGame?.calculation_status === "done" && mostRecentTeamTrends) && (
                        <div>
                            {/* <RatingDropDown ratingTimeframe={ratingTimeframe} handleChange={handleRatingTimeFrameChange} /> */}
                            <SingleGameTeamTrends relevantGame={mostRecentGame} trends={mostRecentTeamTrends} ratingTimeframe={ratingTimeframe} />
                            {isMobile ? (
                                <SingleGameMobileList relevantGame={mostRecentGame} ratingTimeframe={ratingTimeframe}/>
                            ) : (
                                <SingleGameTable relevantGame={mostRecentGame} ratingTimeframe={ratingTimeframe}/>
                            )}
                        </div>
                    )}
                </div>
            )}
            {!isActiveSub && (
                <NotPremium />
            )}
        </div>
    )
}